export const taskStrings = {
  acceptCall: 'Accept Call',
  accept: 'Accept',
  holdAndAccept: 'Hold & Accept',
  reject: 'Reject',
  noMicrophone: 'Microphone not connected',
} as const;
